<template>
    <text-overflow-styled>
        <span>
            <slot />
        </span>
    </text-overflow-styled>
</template>
<script>
import styled from "vue-styled-components";

const TextOverflowStyled = styled.div`
    display: flex;

    span {
        flex: 1;
        width: 1px;

        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        word-break: break-all;
    }
`;

export default {
    name: "TextOverflow",
    props: {},
    methods: {},
    components: {
        TextOverflowStyled
    }
};
</script>